import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { StockVolumeByProductListChart, VendingPackageVolumeByProductListChart } from '@frontend/chart/components';
import { useEffect, useState } from 'react';

import { getLast30DaysChartRange } from '../../../statistics/pudo/last-30-days-chart-range';
import { useInsightFetchRange } from '../insight-detail/use-insight-fetch-range';
import { TimeToStockoutItem, buildTimeToStockoutItems } from './build-time-to-stockout';

const LOOKBACK_DAYS = 30;
const ITEM_LIMIT = 10;

export const useVendingTimeToStockoutList = (accountId: string) => {
    const [items, setItems] = useState<TimeToStockoutItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast30DaysChartRange);

    useEffect(() => {
        if (!accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;
        const rangeParams = {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams
        };

        Promise.all([
            ChartClient.fetchChartData(accountId, StockVolumeByProductListChart.definition, rangeParams),
            ChartClient.fetchChartData(accountId, VendingPackageVolumeByProductListChart.definition, rangeParams)
        ])
            .then(([stock, consumption]) => {
                if (cancelled) return;
                setItems(buildTimeToStockoutItems(stock, consumption, LOOKBACK_DAYS).slice(0, ITEM_LIMIT));
            })
            .catch(() => {
                if (!cancelled) {
                    setItems([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [accountId, fetchRange.key]);

    return { items, isLoading };
};
